export default __webpack_public_path__ + "3ddc28ff4faea538f3541ba70751ddf5.svg";